import React, { useEffect, useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import Cookies from "js-cookie";
const apiUrl = process.env.REACT_APP_API_URL;

// Translations for English, Hindi, and Kannada
const translations = {
  en: {
    header: "Present Address",
    addressLabel: "Address",
    addressPlaceholder: "Type your address...",
    cityLabel: "Village/City/Town",
    cityPlaceholder: "Type your village/city/town...",
    pinLabel: "Pin Code",
    pinPlaceholder: "Type your pin code...",
    errorCity: "Please enter the city.",
    errorZip: "Please enter the pin code.",
    errorValidCity: "Please enter a valid city.",
    errorValidZip: "Please enter a valid pin code.",
    ok: "OK",
    moveError:"Please answer the current question before proceeding to the next one.",
  },
  Hi: {
    header: "वर्तमान पता",
    addressLabel: "पता",
    addressPlaceholder: "अपना पता लिखें...",
    cityLabel: "गाँव/शहर/कस्बा",
    cityPlaceholder: "अपना गाँव/शहर/कस्बा लिखें...",
    pinLabel: "पिन कोड",
    pinPlaceholder: "अपना पिन कोड लिखें...",
    errorCity: "कृपया शहर दर्ज करें।",
    errorZip: "कृपया पिन कोड दर्ज करें।",
    errorValidCity: "कृपया वैध शहर दर्ज करें।",
    errorValidZip: "कृपया वैध पिन कोड दर्ज करें।",
    ok: "ठीक है",
    moveError:"कृपया अगले प्रश्न पर जाने से पहले वर्तमान प्रश्न का उत्तर दें।",
  },
  Kn: {
    header: "ಪ್ರಸ್ತುತ ವಿಳಾಸ",
    addressLabel: "ವಿಳಾಸ",
    addressPlaceholder: "ನಿಮ್ಮ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ...",
    cityLabel: "ಗ್ರಾಮ/ನಗರ/ಪಟ್ಟಣ",
    cityPlaceholder: "ನಿಮ್ಮ ಗ್ರಾಮ/ನಗರ/ಪಟ್ಟಣವನ್ನು ನಮೂದಿಸಿ...",
    pinLabel: "ಪಿನ್ ಕೋಡ್",
    pinPlaceholder: "ನಿಮ್ಮ ಪಿನ್ ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ...",
    errorCity: "ದಯವಿಟ್ಟು ನಗರವನ್ನು ನಮೂದಿಸಿ.",
    errorZip: "ದಯವಿಟ್ಟು ಪಿನ್ ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ.",
    errorValidCity: "ದಯವಿಟ್ಟು ಸರಿಯಾದ ನಗರವನ್ನು ನಮೂದಿಸಿ.",
    errorValidZip: "ದಯವಿಟ್ಟು ಸರಿಯಾದ ಪಿನ್ ಕೋಡ್ ಅನ್ನು ನಮೂದಿಸಿ.",
    ok: "ಸರಿ",
    moveError:"ದಯವಿಟ್ಟು ಮುಂದಿನ ಪ್ರಶ್ನೆಗೆ ಹೋಗುವ ಮೊದಲು ಪ್ರಸ್ತುತ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರ ನೀಡಿ.",

  },
};

const VictimAddress = ({ onNext, onVictimAddressSelected, onQuestion, apiKey, botToken, vist_id, app_ver, answer,selectedLang }) => {
  const [address, setAddress] = useState({
    address1: "",
    city: "",
    zip: "",
  });
  const [error, setError] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  // Mapping language codes to audio source files
  const audioMap = {
    en: "audio/English BOT Audios/victimaddress.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio12.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio12.m4a",
    tcy: "audio/cybervictim_tcy.mp3"
  };


  // Update audio source when language or playing state changes
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
      audioRef.current.load();
      if (isPlaying) {
        audioRef.current.play();
      }
    }
  }, [selectedLang, isPlaying]);

       useEffect(() => {
           const handler = () => {
            if (audioRef.current) {
               audioRef.current.pause();
               audioRef.current.currentTime = 0;
                setIsPlaying(false);
              }
            };
            window.addEventListener('pauseAllAudio', handler);
            return () => window.removeEventListener('pauseAllAudio', handler);
          }, []);

  // Load previously saved address from localStorage (if available)
  useEffect(() => {
    const storedAddress = localStorage.getItem('address');
    if (storedAddress) {
      const parsedAddress = JSON.parse(storedAddress);
      setAddress(parsedAddress);
      onVictimAddressSelected(parsedAddress);
    }
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;
    // Save individual field values in localStorage as needed
    localStorage.setItem(id, JSON.stringify(value));

    if (id === 'address1' || id === 'city') {
      // Allow alphanumeric, spaces, hyphens, underscores and forward slash
      if (/^[a-zA-Z0-9\s\-_\/]*$/.test(value) && value.length <= 100) {
        setAddress((prev) => ({
          ...prev,
          [id]: value,
        }));
        setError("");
      }
    } else if (id === 'zip') {
      // Zip (pin) code: allow only digits
      if (/^\d*$/.test(value)) {
        setAddress((prev) => ({
          ...prev,
          [id]: value,
        }));
        setError("");
      }
    } else {
      setAddress((prev) => ({
        ...prev,
        [id]: value,
      }));
      setError("");
    }
  };

  const handleOkClick = async (e) => {
    e.preventDefault();
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    localStorage.setItem('address', JSON.stringify(address));
    onVictimAddressSelected(address);

    if (!address.city) {
      setError('errorCity');
      return;
    }
    if (!address.zip) {
      setError('errorZip');
      return;
    }
    if (address.city.length < 2) {
      setError('errorValidCity');
      return;
    }
    if (address.zip.length !== 6) {
      setError('errorValidZip');
      return;
    }

    const dataToSubmit = {
      api_key: apiKey,
      visitor_token: vist_id,
      qtion_id: "66f65376898d6",
      qtion_num: "10",
      address: address.address1,
      village: address.city,
      post_cod: address.zip,
      lac_token: botToken,
      app_ver: app_ver,
      bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
    };

    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_addrs`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSubmit),
      });
      if (!response.ok) {
        throw new Error("Failed to save address");
      }
      const data = await response.json();
      if (data.resp.error_code === "0") {
        onVictimAddressSelected(address);
        onNext(12);
        onQuestion(13);
        setError("");
      } else {
        setError("Enter valid address");
      }
      localStorage.setItem('address', JSON.stringify(address));
      onVictimAddressSelected(address);
    } catch (error) {
      console.error("Error saving data:", error);
      setError("Failed to save address data");
    }
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="question">
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h2>{translations[selectedLang].header}</h2>
            <button onClick={toggleAudio} className="audio-button">
              {isPlaying ? <FaPause color="White" size={12} style={{ marginBottom: '20px' }} /> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }}/>}
            </button>
          </div>
          <audio ref={audioRef} onEnded={handleAudioEnd}>
            <source src={audioMap[selectedLang]} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <div style={{ position: "relative", zIndex: "9" }}>
            <p style={{ margin: "5px", marginTop: "5px" }} htmlFor="address1">
              {translations[selectedLang].addressLabel}
            </p>
            <input
              className="text-input"
              value={address.address1}
              onChange={handleChange}
              placeholder={translations[selectedLang].addressPlaceholder}
              id="address1"
              autoComplete="off"
              name="address1"
            />
            <p style={{ margin: "5px", marginTop: "5px" }} htmlFor="city">
              {translations[selectedLang].cityLabel} <span style={{ color: "red" }}>*</span>
            </p>
            <input
              className="text-input"
              value={address.city}
              onChange={handleChange}
              placeholder={translations[selectedLang].cityPlaceholder}
              id="city"
              autoComplete="off"
              name="city"
            />
            <p style={{ margin: "5px", marginTop: "5px" }} htmlFor="zip">
              {translations[selectedLang].pinLabel} <span style={{ color: "red" }}>*</span>
            </p>
            <input
              className="text-input"
              value={address.zip}
              onChange={handleChange}
              placeholder={translations[selectedLang].pinPlaceholder}
              id="zip"
              autoComplete="off"
              name="zip"
              maxLength="6"
              inputMode="numeric"
            />
                      <div style={{ display: "flex", alignItems: "center", marginTop: "10px", position:'relative', zIndex:'9' }}>
            <button type="button" className="ok-btn" onClick={handleOkClick}>
              {translations[selectedLang].ok}
            </button>
          </div>
          </div>

          {error && (
            <p className="bank-error" style={{ position: "relative", zIndex: "1000" }}>
              {translations[selectedLang][error]}
            </p>
          )}
          {answer[11] && (
            <p className="alert-box" style={{ zIndex: "1000" }}>
              {translations[selectedLang].moveError}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default VictimAddress;
